const NotFoundCard = () =>{
    return(
        <div className="d-flex  justify-content-center align-items-center bg-light">
        <div className="p-4 bg-white rounded text-center">
          <h4>No bookings Available</h4>
        </div>
      </div>
    )
}

export default NotFoundCard